export default __webpack_public_path__ + "e70a69a7989bae6c3157427d44a664a5.svg";